import Datetime from 'react-datetime'
import moment from 'moment'
import type { DeliverySiteOption, DeliverySiteState } from '../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../formCheckClasses'

interface Props {
  isView: boolean
  deliverySite: DeliverySiteState
  updateDeliverySite: (patch: Partial<DeliverySiteState>) => void
}

const DELIVERY_SITE_OPTIONS: { value: DeliverySiteOption; label: string }[] = [
  { value: 'factory', label: 'เช็คโรงงานมีเสาเข็ม' },
  { value: 'arrival', label: 'เสาเข็มได้อายุวันที่' },
  { value: 'completed', label: 'เรียบร้อย' },
  { value: 'not_completed', label: 'ยังไม่เรียบร้อย' },
]

const DeliverySiteSection: React.FC<Props> = ({ isView, deliverySite, updateDeliverySite }) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>สถานที่ส่งเสาเข็ม</div>
        </div>
        <div className='card-body'>
          <div className='d-flex flex-column gap-4'>
            {DELIVERY_SITE_OPTIONS.map(opt => (
              <div key={opt.value} className='d-flex flex-wrap align-items-center gap-3'>
                <div className={wonFormCheckRow}>
                  <input
                    className={wonFormCheckInput}
                    type='radio'
                    name='won-delivery-site-option'
                    id={`won-delivery-site-${opt.value}`}
                    checked={deliverySite.option === opt.value}
                    disabled={isView}
                    onChange={() => updateDeliverySite({ option: opt.value })}
                  />
                  <label className={wonFormCheckLabel} htmlFor={`won-delivery-site-${opt.value}`}>
                    {opt.label}
                  </label>
                </div>
                {opt.value === 'arrival' && (
                  <Datetime
                    locale='en'
                    dateFormat='DD/MM/YYYY'
                    timeFormat={false}
                    value={deliverySite.arrivalDate ?? undefined}
                    onChange={(val: any) => {
                      if (moment.isMoment(val) || val instanceof Date) {
                        updateDeliverySite({
                          arrivalDate: moment(val).toDate(),
                          option: 'arrival',
                        })
                      }
                    }}
                    renderInput={props => (
                      <input
                        {...props}
                        autoComplete='off'
                        className='form-control form-control-sm'
                        style={{ maxWidth: 160 }}
                        disabled={isView || deliverySite.option !== 'arrival'}
                      />
                    )}
                    closeOnClickOutside
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeliverySiteSection
